export const APPLICATION_LIST = [
    {
        id: "abbvie_pro",
        name: "AbbVie Pro",
    },
    {
        id: "abbvie_pro_medical",
        name: "AbbVie Pro Medical",
    },
    {
        id: "allergan_pro_ami",
        name: "AbbVie Pro AMI",
    },
    {
        id: "allergan_pro",
        name: "Allergan Pro",
    },
];

export const BASIC_LOGIN_APP_LIST = [
    {
        id: "abbvie_pro",
        name: "Abbvie Pro",
    },
    {
        id: "abbvie_pro_medical",
        name: "Abbvie Pro Medical",
    },
    {
        id: "abbvie_pro_training",
        name: "Abbvie Pro Training",
    },

    {
        id: "allergan_pro_ami",
        name: "Abbvie Pro AMI",
    },
    {
        id: "abbvie_lmbc",
        name: "Abbvie LMBC",
    },

    {
        id: "abbvie_lets_talk_eczema_ous",
        name: "Abbvie Lets Talk Eczema",
    },
    {
        id: "abbvie_talkoverra_ous",
        name: "Abbvie Talkoverra",
    },
    {
        id: "abbvie_skyrizi",
        name: "Abbvie Skyrizi",
    },
    {
        id: "abbvie_skyrizi_me",
        name: "Abbvie Skyrizi ME",
    },
    {
        id: "abbvie_rinvoq",
        name: "Abbvie Rinvoq",
    },
    {
        id: "abbvie_rinvoq_me",
        name: "Abbvie Rinvoq ME",
    },
    {
        id: "abbvie_infocenter",
        name: "Abbvie Infocenter",
    },
    {
        id: "allergan_pro",
        name: "Allergan Pro",
    },
    {
        id: "infocenter_rheuma",
        name: "Infocenter Rheuma",
    },
    {
        id: "infocenter_gastro",
        name: "Infocenter Gastro",
    },
    {
        id: "skyrizi_de",
        name: "Skyrizi DE",
    },

    {
        id: "tale_of_two_patients",
        name: "Tale of Two Patients",
    },
    {
        id: "optive",
        name: "Optive",
    },
    {
        id: "xen_implantat",
        name: "Xen Implantat",
    },
    {
        id: "abbvie_care_ous",
        name: "Abbvie Care",
    },
    {
        id: "arzneimittelsuche",
        name: "Arzneimittelsuche",
    },
    {
        id: "skyrizi",
        name: "Skyrizi",
    },
    {
        id: "meinparkinson",
        name: "Meinparkinson",
    },
    {
        id: "healthcareheroes",
        name: "Healthcareheroes",
    },
    {
        id: "abbvie_pro_acuiti",
        name: "Abbvie Pro ACUITI",
    },
    {
        id: "yasamlardaizbirak",
        name: "Yasamlardaizbirak",
    },
    {
        id: "support_center",
        name: "Support Center",
    },
    {
        id: "sitegenarator",
        name: "Sitegenarator",
    },
    {
        id: "dry-eye",
        name: "Dry Eye",
    },
    {
        id: "acne-inversa",
        name: "Acne Inversa",
    },
    {
        id: "sagliginicinkesfet",
        name: "Sagliginicinkesfet",
    },
];

export const SITE_ADMIN_APP_LIST = [
    {
        id: "abbvie_pro",
        name: "Abbvie Pro",
    },
    {
        id: "allergan_pro",
        name: "Allergan Pro",
    },
    {
        id: "abbvie_lmbc",
        name: "Abbvie LMBC",
    },
    {
        id: "allergan_pro_ami",
        name: "Abbvie Medical Institute",
    },
];

export const ROUTE_AUTH_APP_LIST = {
    ABBVIEPRO: "abbvie-pro",
    ALLERGANPRO: "allergan-pro",
    ABBVIELMBC: "abbvie-lmbc",
};

export const VEEVA_INSTANCE_TYPES = [
    {
        id: "latin",
        name: "Latin",
    },
    {
        id: "europe",
        name: "Europe",
    },
];

export const AEM_ENVIRONMENTS = [
    {
        id: "DEV2",
        name: "DEV2",
    },
    {
        id: "DEV2-PREVIEW",
        name: "DEV2 PREVIEW",
    },
    {
        id: "DEV",
        name: "DEV",
    },
    {
        id: "DEV-PREVIEW",
        name: "DEV PREVIEW",
    },
    {
        id: "QA",
        name: "QA",
    },
    {
        id: "QA-PREVIEW",
        name: "QA PREVIEW",
    },
    {
        id: "STAGE",
        name: "STAGE",
    },
    {
        id: "STAGE-PREVIEW",
        name: "STAGE PREVIEW",
    },
    {
        id: "PREVIEW",
        name: "PREVIEW",
    },
    {
        id: "PROD-PREVIEW",
        name: "PROD PREVIEW",
    },
    {
        id: "PROD",
        name: "PROD",
    },
];

export const PIAP_ENVIRONMENTS = [
    {
        id: "dev",
        name: "Dev",
    },
    {
        id: "qa",
        name: "QA",
    },
    {
        id: "preview",
        name: "Preview",
    },
    {
        id: "prod",
        name: "Production",
    },
];

export const ICC_ENVIRONMENTS = [
    {
        id: "UAT",
        name: "UAT",
    },
    {
        id: "PROD",
        name: "Production",
    },
];

export const VEEVA_CONFIG_COUNTRY_TYPES = [
    {
        id: "1",
        name: "Single country single language",
    },
    {
        id: "2",
        name: "Single country multiple language",
    },
    {
        id: "3",
        name: "Group of countries",
    },
];

export const VEEVA_CONFIG_IDENTITY_TYPE = [
    {
        id: "professionalId",
        name: "Professional ID",
    },
    {
        id: "nationalId",
        name: "National ID",
    },
];
